import type { TransactionImportType } from "@types";

export const IMPORT_TEMPLATE_FILES: Record<TransactionImportType, string> = {
  DESPESA: "modelo_importacao_despesas_TPG.xlsx",
  RECEITA: "modelo_importacao_receitas_TPG.xlsx",
};

export const downloadImportTemplate = (type: TransactionImportType) => {
  const fileName = IMPORT_TEMPLATE_FILES[type];
  const link = document.createElement("a");
  link.href = `/templates/${fileName}`;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
};
